function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M18.895 10.323v.731a7.95 7.95 0 11-4.715-7.267",
  stroke: "currentColor",
  strokeWidth: 1.231,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.894 4.694l-7.95 7.958-2.385-2.385",
  stroke: "currentColor",
  strokeWidth: 1.199,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgFeatherCheckCircle = function SvgFeatherCheckCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22",
    fill: "none"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjIiIGhlaWdodD0iMjIiIHZpZXdCb3g9IjAgMCAyMiAyMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE4Ljg5NDkgMTAuMzIyNlYxMS4wNTQxQzE4Ljg5MzkgMTIuNzY4NSAxOC4zMzg4IDE0LjQzNjcgMTcuMzEyMyAxNS44MDk4QzE2LjI4NTcgMTcuMTgzIDE0Ljg0MjggMTguMTg3NSAxMy4xOTg4IDE4LjY3MzZDMTEuNTU0NyAxOS4xNTk3IDkuNzk3NSAxOS4xMDE0IDguMTg5MyAxOC41MDcyQzYuNTgxMSAxNy45MTMxIDUuMjA4MDUgMTYuODE1IDQuMjc0OTIgMTUuMzc2N0MzLjM0MTc4IDEzLjkzODUgMi44OTg1NyAxMi4yMzcxIDMuMDExMzcgMTAuNTI2NEMzLjEyNDE4IDguODE1NjggMy43ODY5NiA3LjE4NzI1IDQuOTAwODcgNS44ODM5OEM2LjAxNDc3IDQuNTgwNzEgNy41MjAxMyAzLjY3MjQzIDkuMTkyNDIgMy4yOTQ2QzEwLjg2NDcgMi45MTY3NyAxMi42MTQzIDMuMDg5NjMgMTQuMTgwMyAzLjc4NzQxIiBzdHJva2U9IiMwMDAwMDAiIHN0cm9rZS13aWR0aD0iMS4yMzA1NCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xOC44OTQxIDQuNjkzODVMMTAuOTQzNyAxMi42NTIyTDguNTU4NTkgMTAuMjY3MSIgc3Ryb2tlPSIjMDAwMDAwIiBzdHJva2Utd2lkdGg9IjEuMTk4NTgiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K";
export { SvgFeatherCheckCircle as ReactComponent };